import { watchApiMakeRequest } from './ApiMakeRequestSaga';

const ApiMakeRequestSagas = [watchApiMakeRequest()];

export default ApiMakeRequestSagas;
